import { useEffect } from 'react'
import { Spinner } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { useBilanciaCliente } from '../../../hooks/bilance'
import CardCliente from '../CardCliente'
import CardDatiBilancia from '../CardDatiBilancia'
import CardRapportoTaraturaBilancia from '../CardRapportoTaraturaBilancia'
import CardStoricoInterventiBilancia from '../CardStoricoInterventiBilancia'
import CardVerificazionePeriodicaBilancia from '../CardVerificazionePeriodicaBilanica'
import { AreaClientiRedirect } from '../../AreaClientiRedirect'

export default function BilanciaDettaglioCliente() {
  const { id } = useParams()
  const bilancia = useBilanciaCliente(String(id))
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  if (bilancia.isLoading) {
    return (
      <div className="page">
        <div className="h-100 d-flex justify-content-center align-items-center">
          <Spinner animation="border" role="status" variant="secondary" />
        </div>
      </div>
    )
  }

  if (bilancia.isError) {
    return <AreaClientiRedirect message="Pagina non disponibile" />
  }

  return (
    <div className="page">
      <div className="row mt-4">
        <div className="col-12">
          <div className="d-flex align-items-center">
            <div
              onClick={() => {
                navigate(-1)
              }}
              className="p-sm no-link d-flex align-items-center pointer"
            >
              <span className="material-icons text-secondary">scale</span>
              <span className="ms-2">Lista bilance</span>
            </div>
            <span className="material-icons text-secondary">chevron_right</span>
            <span className="ms-2 p-sm bg-secondary-light p-2 text-secondary rounded">Dettaglio bilancia</span>
          </div>
        </div>
        <div className="col-12 d-flex align-items-center">
          <div>
            <h1 className="title me-4 mb-0">
              Bilancia {bilancia.data?.matricola} {bilancia.data?.sigla ? `(${bilancia.data?.sigla})` : ''}
            </h1>
          </div>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-6">
          <CardDatiBilancia bilancia={bilancia} />
          <CardCliente bilancia={bilancia} />
        </div>
        <div className="col-md-6">
          {bilancia.data?.verif_periodica && <CardVerificazionePeriodicaBilancia bilancia={bilancia} />}
          <CardRapportoTaraturaBilancia
            bilancia={bilancia}
            rapportoTaratura={bilancia.data?.rapporto_taratura ?? false}
          />
          <CardStoricoInterventiBilancia bilancia={bilancia} />
        </div>
      </div>
    </div>
  )
}
